import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { Wifi } from "lucide-react";
import PagePlacements from "@/components/PagePlacements";

const ICON_LABEL_SIZES = {
  sm: "text-[10px] px-2 py-0.5",
  md: "text-xs px-2.5 py-1.5",
  lg: "text-sm px-3 py-2",
  xl: "text-base px-4 py-2.5",
};

export default function InternetMobilny() {
  const { mobile_internet_plans, pages } = useContent();
  const page = pages?.internet || {};
  const showFeatured = page.show_featured !== false; // domyślnie true
  const bullets = Array.isArray(page.bullets) && page.bullets.length > 0
    ? page.bullets
    : ["Prędkość LTE / 5G w całej Polsce", "Bez umowy lojalnościowej", "Aktywacja w kilka minut"];
  const ctaLabel = page.cta_button || "Zamawiam";
  return (
    <div data-testid="internet-mobilny-page" className="relative max-w-7xl mx-auto px-6 py-20">
      <div className="max-w-2xl">
        <div className="text-white/70 text-xs uppercase tracking-widest font-semibold">{page.eyebrow || "Internet mobilny"}</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black text-white mt-3">
          {page.hero_title || "Internet, który nie znika"}
        </h1>
        <p className="text-white/70 mt-4 whitespace-pre-line">
          {(page.hero_subtitle || "Trzy pakiety Internetu mobilnego do wyboru. Dla routera LTE/5G, tabletu lub jako drugi numer do internetu.").replace(/\.\s+/g, ".\n")}
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mt-12">
        {mobile_internet_plans.map((p, i) => (
          <div
            key={p.id}
            data-testid={`mi-card-${p.id}`}
            className={`rm-card p-8 flex flex-col plan-card ${showFeatured && i === 1 ? "ring-2 ring-[#dc2626]" : ""}`}
          >
            {showFeatured && i === 1 && (
              <div className="self-start mb-4 px-3 py-1 bg-[#dc2626] text-white text-xs font-bold rounded-full uppercase tracking-wider">
                Najczęściej wybierany
              </div>
            )}
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-xl bg-[#1f3a8a]/10 text-[#1f3a8a] flex items-center justify-center flex-shrink-0">
                <Wifi size={22} />
              </div>
              {p.icon_label && (
                <div
                  data-testid={`mi-icon-label-${p.id}`}
                  className={`font-bold uppercase tracking-wider text-[#1f3a8a] bg-[#1f3a8a]/10 rounded-md ${ICON_LABEL_SIZES[p.icon_label_size] || ICON_LABEL_SIZES.md}`}
                >
                  {p.icon_label}
                </div>
              )}
            </div>
            <h3 className="font-display text-3xl font-bold text-[#0f172a]">{p.name}</h3>
            <p className="text-sm text-slate-500 mt-1">Internet mobilny</p>
            <div className="mt-6 flex items-baseline gap-1">
              <span className="font-display text-5xl font-black text-[#1f3a8a]">{p.price}</span>
              <span className="text-lg text-slate-500">zł{p.period}</span>
            </div>

            <ul className="mt-6 space-y-3 flex-grow">
              {bullets.map((b, bi) => (
                <li key={bi} className="flex items-start gap-2 text-sm text-slate-700">
                  <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-[#1f3a8a]/10 text-[#1f3a8a] flex items-center justify-center">
                    <Check size={12} strokeWidth={3} />
                  </span>
                  {b}
                </li>
              ))}
            </ul>

            <Link
              to={`/zamow-sim?plan=${p.id}`}
              data-testid={`mi-cta-${p.id}`}
              className={`mt-8 text-center font-bold rounded-full py-3 transition-all ${
                showFeatured && i === 1 ? "bg-[#dc2626] text-white hover:bg-[#ef4444]" : "bg-[#1f3a8a] text-white hover:bg-[#15296b]"
              }`}
            >
              {ctaLabel}
            </Link>
          </div>
        ))}
      </div>
      <PagePlacements page="internet" />
    </div>
  );
}
